import s from './scss/loadingbar.scss';

const Loadingbar = ({ percent }) => {
  return (
    <div className={s.loadingbar}>
      <div className={s.wrapper}>
        <div className={s.bar} style={{ width: percent + '%' }} />
        <div className={s.text}>
          <span>{`${Math.round(percent)}%`}</span>
        </div>
      </div>
    </div>
  );
};

export default Loadingbar;
